import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const intShowSuggestedData = createAsyncThunk(
  "influencerRequest/intShowSuggestedData",
  async ({ payload, currectUrl }, { rejectWithValue }) => {
    try {
      let response;
      if (currectUrl === "ongoing-details") {
        response = await axiosInstance.post(
          "/sales/int_show_suggested_inf",
          payload,
        );
      } else if (currectUrl === "ongoing-onboarding-details") {
        response = await axiosInstance.post(
          "/dm/int_show_suggested_inf_onboard",
          payload,
        );
      } else if (currectUrl === "completed-details") {
        response = await axiosInstance.post(
          "/sales/int_show_suggested_inf",
          payload,
        );
      } else if (currectUrl === "completed-onboarding-details") {
        response = await axiosInstance.post(
          "/dm/int_show_suggested_inf_onboard",
          payload,
        );
      }

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || err.message || "Something went wrong",
      );
    }
  },
);


export const intBiddingSuggestedData = createAsyncThunk(
  "influencerRequest/intBiddingSuggestedData",
  async ({ requestDataToSend, currectUrl }, { rejectWithValue }) => {
    try {
      let response;

      if (currectUrl === "ongoing-details") {
        response = await axiosInstance.post(
          "/sales/suggest_to_onboarding",
          requestDataToSend,
        );
      } else if (currectUrl === "ongoing-onboarding-details") {
        response = await axiosInstance.post(
          "/dm/int_suggest_to_sales",
          requestDataToSend,
        );
      } else {
        throw new Error("Invalid URL type");
      }

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || err.message || "Something went wrong",
      );
    }
  },
);

export const intBiddingAmountApproved = createAsyncThunk(
  "influencerRequest/intBiddingAmountApproved",
  async (requestFormData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/common/int_bidding_status",
        requestFormData,
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || err.message || "Something went wrong",
      );
    }
  },
);

const initialState = {
  loading: false,
  suggestedData: null,
  error: null,
  success: false,
};

const InfluencerForBiddingSlice = createSlice({
  name: "influencerRequest",
  initialState,
  reducers: {
    resetSuggestedData: (state) => {
      state.loading = false;
      state.suggestedData = null;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // 🔄 Pending
      .addCase(intShowSuggestedData.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })

      // ✅ Fulfilled
      .addCase(intShowSuggestedData.fulfilled, (state, action) => {
        state.loading = false;
        state.suggestedData = action.payload;
        state.success = true;
      })

      // ❌ Rejected
      .addCase(intShowSuggestedData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch data";
        state.success = false;
      });
  },
});

export const { resetSuggestedData } = InfluencerForBiddingSlice.actions;

export default InfluencerForBiddingSlice.reducer;
